// src/utils/sound.ts
// Robust audio helper for Tauri and browsers (autoplay-safe after first user gesture).

let dingEl: HTMLAudioElement | null = null;
let unlocked = false;

// In CRA/Vite/Next public assets are served from /
const SOUND_SRC = (typeof process !== "undefined" && (process as any).env?.PUBLIC_URL)
  ? `${(process as any).env.PUBLIC_URL}/sounds/new_order.wav`
  : `/sounds/new_order.wav`;

// Must be called on any user gesture (click/tap) early in app lifecycle
export function unlockAudio() {
  if (unlocked) return;
  try {
    if (!dingEl) {
      dingEl = new Audio(SOUND_SRC);
      dingEl.preload = "auto";
      dingEl.volume = 1.0;
    }
    // play+pause to unlock on iOS/Safari/Chromium policies
    dingEl.muted = true;
    void dingEl.play().catch(() => {});
    dingEl.pause();
    dingEl.currentTime = 0;
    dingEl.muted = false;
    unlocked = true;
  } catch {}
}

// Safe play (no crash if blocked). If not yet unlocked, we still try; in Tauri it usually works.
export async function playKitchenDing() {
  try {
    if (!dingEl) {
      dingEl = new Audio(SOUND_SRC);
      dingEl.preload = "auto";
      dingEl.volume = 1.0;
    }
    dingEl.currentTime = 0;
    await dingEl.play();
  } catch (e) {
    // swallow - likely autoplay policy, will work after unlockAudio()
  }
}